var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("CompassButton", {
        staticClass: "addBankBtn",
        attrs: { label: _vm.$t.__("common.actions.add_bank_account") },
        on: { click: _vm.addAccount }
      }),
      _vm._v(" "),
      _c("h2", [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Informations bancaires de la société")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("bank-table", {
        attrs: {
          title: _vm.$t.__(
            "preferences.Bank.bank_accounts_linked_to_your_account_list"
          ),
          subtitle: _vm.$t.__(
            "preferences.Bank.manage_bank_accounts_linked_to_sellsy"
          ),
          banks: _vm.activateAccount
        },
        on: { open: _vm.updateForm }
      }),
      _vm._v(" "),
      _vm.deactivateAccount.length > 0
        ? _c("bank-table", {
            attrs: {
              title: _vm.$t.__("preferences.Bank.disabled_bank_accounts_list"),
              subtitle: _vm.$t.__(
                "preferences.Bank.bank_account_not_synchronized_list"
              ),
              banks: _vm.deactivateAccount
            },
            on: { open: _vm.updateForm }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "CompassDialog",
        {
          staticClass: "bank-modal",
          attrs: {
            visible: _vm.dialogVisible,
            size: "small",
            title: _vm.$t.__("preferences.Bank.add_account")
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("template", { slot: "default" }, [
            _c("div", { staticClass: "dialog__default" }, [
              _c(
                "p",
                {
                  staticClass: "gray-60 typographies-paragraph-medium-regular"
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Sélectionnez le type de compte que vous souhaitez ajouter : "
                        )
                      ) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row gutters mt-1" }, [
                _c("div", { staticClass: "col span_6 well acenter" }, [
                  _c("h4", [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$l10n.__("Mode synchronisé")) +
                        "\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Votre compte est directement connecté à Sellsy."
                            )
                          ) +
                          "\n                            "
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Sélectionnez ce choix si vous souhaitez voir le compte dans le Rapprochement Bancaire."
                            )
                          ) +
                          "\n                            "
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("CompassButton", {
                        attrs: {
                          label: _vm.$t.__("common.actions.select"),
                          onclick: "BankReconciliation.redirectBudgetInsight();"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col span_6 well acenter" }, [
                  _c("h4", [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$l10n.__("Mode manuel")) +
                        "\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Votre compte est utilisé dans la partie Règlements."
                            )
                          )
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Sélectionnez ce choix si vous souhaitez voir le compte dans les règlements et dans les RIB."
                            )
                          )
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("CompassButton", {
                        attrs: { label: _vm.$t.__("common.actions.select") },
                        on: { click: _vm.createForm }
                      })
                    ],
                    1
                  )
                ])
              ])
            ])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _vm.formVisible
        ? _c("bank-form", {
            attrs: {
              bankId: _vm.bankToUpdate,
              defaultBankCode: _vm.defaultBankCode,
              status: _vm.statusBankToUpdate,
              bankCodes: _vm.bankCodes
            },
            on: { close: _vm.closeForm }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }